import {injectReducer} from '../../store/reducers'
import userService from '../../services/user-service'
import _ from 'lodash';

export default (store) => ({
  path: 'login',
  isDemoAllowed: true,
  onEnter: forwardToHomeIfAlreadyLoggedIn(store),
  /*  Async getComponent is only invoked when route matches   */
  getComponent(nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const Login = require('./containers/Login').default
      const {loginReducer} = require('./modules/login')

      /*  Add the reducer to the store on key 'counter'  */
      // injectReducer(store, { key: 'counter', reducer })
      injectReducer(store, {key: 'loginState', reducer: loginReducer})
      cb(null, Login)

      /* Webpack named bundle   */
    }, 'campaign')
  }
})

function forwardToHomeIfAlreadyLoggedIn(store) {
  return (nextState, replace, callback) => {
    let {dispatch} = store
    return userService.getCurrentUser()
      .then((user) => {
        dispatch({
          type: 'LOG_IN_COMPLETE',
          data: {
            user: user
          }
        })
        let isCustomerAssociate = userService.isCustomerAssociate(user);
        let userRole = userService.getUserRole(user)
        let redirectRoute = _.get(_.get(userRole,'generalConfig',{}),'dashboardPrimaryPage','')
        if(!_.isEmpty(redirectRoute)){
          let redirection = userService.routeStringTemplate(redirectRoute)
          replace(redirection)
        }else{
          if (isCustomerAssociate) {
            replace('/customer-details')
          } else {
            let isDemoUser = _.endsWith(_.get(user, 'tenant.esKey'), '_demo')
            replace(isDemoUser ? '/purchases-clustering-analytics' : '/home')
          }
        }
        callback()
      }).catch((error) => {
        console.log("error",error)
        // callback()
      })
  }
}



// WEBPACK FOOTER //
// ./src/routes/Login/index.js